import React, { useEffect } from "react";
import { Form, Input, message, Switch } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { apiClient } from "../../../shared/api/AllApi";
import { invalidateCatalog } from "../../../hooks/useCatalogData";
import { FormPage, FormCard, inputStyle, grid2 } from "../../../shared/ui/PageShell";

const UpdateCustomer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [saving, setSaving] = React.useState(false);

  useEffect(() => {
    apiClient.get(`/customers/${id}`)
      .then((res) => {
        const c = res.data || {};
        form.setFieldsValue({
          name: c.name || "",
          phone_number: c.phone_number || "",
          is_pos_default: !!c.is_pos_default,
        });
      })
      .catch(() => message.error(t("fetchError", "Error loading data")));
  }, [id, form, t]);

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await apiClient.put(`/customers/${id}`, values);
      invalidateCatalog("customers");
      message.success(t("successMessage", "Form submitted successfully"));
      navigate("/customers");
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error?.response?.data?.message || t("errorMessage", "Failed to submit form. Please try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      breadcrumb={[t("sidebarSectionContacts", "Contacts"), t("customers", "Customers"), t("edit", "Edit")]}
      title={`${t("edit", "Edit")} ${t("customers", "Customers")}`}
      subtitle={t("updateCustomerDetails", "Update customer details")}
      onBack={() => navigate("/customers")}
      onSave={onSave}
      saving={saving}
    >
      <Form form={form} layout="vertical" requiredMark scrollToFirstError>
        <FormCard title={t("customerInfo", "Customer Information")}>
          <div style={grid2}>
            <Form.Item name="name" label={t("name", "Name")} rules={[{ required: true, message: t("customerNameRequired", "Customer name is required") }]}>
              <Input placeholder={t("enterName", "Enter customer name")} style={inputStyle} prefix={<UserOutlined style={{ color: "#94a3b8" }} />} />
            </Form.Item>
            <Form.Item name="phone_number" label={t("phone", "Phone Number")}>
              <Input placeholder={t("enterPhone", "Enter phone number")} style={inputStyle} />
            </Form.Item>
          </div>
          <Form.Item name="is_pos_default" label={t("posDefaultCustomer", "Default POS Customer")} valuePropName="checked">
            <Switch />
          </Form.Item>
        </FormCard>
      </Form>
    </FormPage>
  );
};

export default UpdateCustomer;
